export interface EventLog {
    type: EventLogType;
    key: string;
    events: IEvent[];
}

export enum EventLogType {
    RESERVE = 'RESERVE',
    PAYMENT = 'PAYMENT',
    RESERVE_PACKAGE = 'RESERVE_PACKAGE',
    PACKAGE_ITEM = 'PACKAGE_ITEM',
    PRICE_RULE = 'PRICE_RULE',
}

export interface IEvent {
    timestamp: Date;
    message: string;
    user: string;
}
